import { Box, Stack } from "@mui/material"
import { Sidebar } from "./Sidebar"
import { Header } from "./Header"
import { ReactElement, useEffect, useState } from "react"
import { useAPI } from "../../hooks/useAPI";
import { useGlobalAtoms } from '../../atoms/globalAtoms';
import { useLocation } from "react-router-dom";
import { Error403 } from "../../pages/errors/Error403";
import { useAuth } from "../../assets/contexts/AuthContext";

interface FrameProps {
  children: ReactElement;
  title?: string;
  toolbarButtons?: ReactElement;
  titleElement?: ReactElement;
}

export const Frame = ({ children, title, toolbarButtons, titleElement }: FrameProps) => {
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const location = useLocation();
  const { permissions, setPermissions, setAllClientPermissons, checkPermission } = useGlobalAtoms();
  const [show403, setShow403] = useState(false);

  useEffect(() => {
    if (isAuthenticated && permissions.length == 0) {
      fetchData('/get-permissions').then(({ errors, data }) => {
        setPermissions(data.user_permissions ?? []);
        setAllClientPermissons(data.all_client_permissions ?? []);
      })
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      if (!checkPermission()) {
        setShow403(true);
      }
    }
  }, [location.pathname, permissions]);

  return (
    <Stack className="frame" flexDirection='row'>
      <Sidebar />
      <Stack flexGrow={1}>
        <Header title={title} toolbarButtons={toolbarButtons} titleElement={titleElement} />
        <Box className="main" p={4} maxHeight="calc(100vh - 100px)" overflow="auto">
          { show403 ? <Error403 /> : children }
        </Box>
      </Stack>
    </Stack>
  )
}